import { CategoryResponse } from "./category";
import { GetRequestPublic } from "./RequestTemplates";

export type ProvidersResponse = [
  {
    active: boolean;
    category: CategoryResponse;
    company: {
      companyName: string;
      externalId: number;
      externalLogoUrl: string;
      id: string;
      imagePath: string;
      slug: string;
    };
    disabled: boolean;
    id: string;
    sortPriority: number;
  }
];

export const fetchProviders = async (
  categoryId: string,
  postalcode: string,
  locationId: number
): Promise<ProvidersResponse> => {
  return GetRequestPublic(`${process.env.API_SERVER_URL}/provider/categoryProvider/category/${categoryId}/partial`, {
    params: {
      postcode: postalcode,
      locationId: locationId,
    },
  }).then((res) => res.data);
};

export const fetchProvider = async (categoryProviderId: string) => {
  return GetRequestPublic(`${process.env.API_SERVER_URL}/provider/categoryProvider/${categoryProviderId}`).then(
    (res) => res.data
  );
};
